import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { baseService } from "./baseService";

const resource = "profile";

export const profileService = {
  useGet: () =>
    useQuery({
      queryKey: [resource, "detail"],
      queryFn: () => baseService.get(`/${resource}`),
      staleTime: Infinity,
    }),

  useUpdate: () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (formData) => baseService.patch(`/update-${resource}`, formData),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [resource] });
      },
    });
  },
};
